export const name = "STDDEV";
export const summary = `An alias of the \`STDDEV_SAMP\` function.`;
export const reference = `
## STDDEV

An alias of the \`STDDEV_SAMP\` function.

\`\`\`
STDDEV(
  [DISTINCT]
  expression
)
[OVER over_clause]

over_clause:
  { named_window | ( [window_specification] ) }

window_specification:
  [named_window]
  [PARTITION BY partition_expression [, ...] ]
  [ORDER BY expression [ { ASC | DESC }] [, ...] ]
  [window_frame_clause]
\`\`\`

### Description

An alias of STDDEV_SAMP.


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/statistical_aggregate_functions
`;
